import { defineComponent as _defineComponent } from 'vue'
import { VignetteRoutes } from "@/types";
import { useSessionStore } from "@/pinia/session";
import { useAppStore } from "@/pinia/app";
import { computed, ref } from "vue";
import DjangoRouterLink from "@/components/links/DjangoRouterLink.vue";
import { useRoute } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationHeader',
  setup(__props) {

const sessionStore = useSessionStore();
const appStore = useAppStore();
const route = useRoute();
const navDrawerExpanded = ref(false);

const hasVignetteAccess = computed(
  () => sessionStore?.hasVignetteAccess ?? false
);

const isLoggedIn = computed(() => sessionStore?.isLoggedIn ?? false);
const isIpUser = computed(() => sessionStore?.isIpUser ?? false);
const pageTitle = computed(() => (appStore?.pageName ?? "") + " - Almanac+");

const accountButtonText = computed(() => {
  return isIpUser.value ? "Login" : "My Account";
});

const accountButtonLink = computed(() => {
  if (isIpUser.value) {
    return `/login/?next=${encodeURIComponent(
      "/almanacplus" + route.fullPath
    )}`;
  }
  return "/my-account";
});

const briefcaseLink = computed(() => {
  if (isIpUser.value) {
    return `/login/?next=${encodeURIComponent("/almanacplus/briefcase/")}`;
  }
  return "/almanacplus/briefcase/";
});

const currentDate = () => {
  return new Date()
    .toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    })
    .toUpperCase();
};

const facebookUrl = computed(() => {
  return `https://www.facebook.com/NationalJournal/?ref=page_internal`;
});

const twitterUrl = computed(() => {
  return `https://twitter.com/nationaljournal`;
});

const linkedInUrl = computed(() => {
  return `https://www.linkedin.com/company/9313`;
});

return { __sfc: true,sessionStore, appStore, route, navDrawerExpanded, hasVignetteAccess, isLoggedIn, isIpUser, pageTitle, accountButtonText, accountButtonLink, briefcaseLink, currentDate, facebookUrl, twitterUrl, linkedInUrl, VignetteRoutes, DjangoRouterLink }
}

})